import { ESJob, Job } from '@/types/job'
import { Box, Stack, Image, Heading, Icon, Text, AspectRatio } from '@/components/Chakra'
import { WorkerFeeText } from './WorkerFeeText'
import { HiCurrencyYen, HiLocationMarker } from 'react-icons/hi'
import { getPrefText } from '@/lib/pref'

type Props = {
  job: ESJob | Job
}

export const JobSimpleCard = ({ job }: Props) => {
  return (
    <>
      <Stack mb={5} direction={'column'} as={'a'} href={`/jobs/${job.id}`}>
        <AspectRatio maxWidth={304} maxHeight={180}>
          <Image alt={''} borderRadius={'md'} objectFit={'contain'} src={job.cover_img_url} />
        </AspectRatio>
        <Box>
          <Heading as={'h3'} fontSize={'md'} noOfLines={2}>
            {job.name}
          </Heading>
          <Stack mt={1} mb={4} direction={'column'} spacing={0}>
            <Stack direction={'row'} align={'center'} color={'gray.500'}>
              <Icon color={'gray.400'} as={HiLocationMarker} />
              <Text fontSize={['xs', 'xs', 'sm']}>
                {getPrefText(job.place?.pref_id || 1)}
                {job.place?.city_name}
              </Text>
            </Stack>
            <Stack direction={'row'} align={'center'} color={'gray.500'}>
              <Icon color={'gray.400'} as={HiCurrencyYen} />
              <Text fontSize={['xs', 'xs', 'sm']}>
                <WorkerFeeText job={job} />
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </>
  )
}
